// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    'backbone',
], (Globals, $, _, Backbone) => {
    const HelpView = Backbone.View.extend({
        model: null,
        initialize() {
        },
        render() {
            const view = this;
            let helptext = '';
            let icontext = '';
            if (Globals.i18n.data['general.help.helptext']) {
                helptext = Globals.i18n._('general.help.helptext');
            }
            if (Globals.i18n.data['general.help.icon']) {
                icontext = Globals.i18n._('general.help.icon');
            }
            $('body').append('<div id="help"><div class="icon sprites_main">' + icontext + '</div><p>' + helptext + '</p></div>');

            const fensterhoehe = $(window).height();
            const hilfe = $('#help');

            hilfe.css('top', fensterhoehe + 'px');

            view.rollOut();
        },
        destroy() {
            const fensterhoehe = $(window).height();
            const hilfe = $('#help');
            $('[data-help]').unbind('mouseleave');
            $('[data-help]').unbind('mouseover');
            hilfe.animate(
                { top: fensterhoehe },
                400,
                () => {
                    hilfe.detach();
                    $('#hilfebutton').removeClass('active');
                }
            );
        },
        resizePos() {
            const fensterhoehe = $(window).height();
            const hilfe = $('#help');
            const neuehoehe = fensterhoehe - (hilfe.height() + 40);
            hilfe.css('top', neuehoehe + 'px');
        },
        rollOut() {
            const view = this;
            const fensterhoehe = $(window).height();
            const hilfe = $('#help');
            const neuehoehe = fensterhoehe - (hilfe.height() + 40);
            hilfe.animate(
                { top: neuehoehe },
                400,
                () => {
                    $(window).resize(() => {
                        view.resizePos();
                    });
                    view.dataHelp();
                }
            );
        },
        dataHelp() {
            const view = this;
            const hilfe = $('#help');
            if ($('#hilfebutton').hasClass('active')) {
                $('[data-help]').unbind('mouseleave');
                $('[data-help]').unbind('mouseover');

                $('[data-help]').each((index, element) => {
                    $(element).mouseenter(e => {
                        e.preventDefault();
                        e.stopPropagation();
                        hilfe.find('p').css('visibility', 'hidden');
                        let value = $(element).attr('data-help');
                        try {
                            if (Globals.i18n.data[value] !== null && !_.isUndefined(Globals.i18n.data[value])) {
                                value = $._(value);
                            }
                        } catch (error) {
                            console.error('Error', error);
                        }
                        hilfe.find('p').JQtextile('textile', value);
                        hilfe.stop(true, true);
                        hilfe.find('p').stop(true, true);
                        view.rollResize();
                    }).mouseleave(e => {
                        e.preventDefault();
                        e.stopPropagation();
                        view.rollIdle();
                    });
                });
            }
        },
        rollResize() {
            // var view = this;
            const fensterhoehe = $(window).height();
            const hilfe = $('#help');
            const idlehoehe = fensterhoehe - 163;
            const neuehoehe = fensterhoehe - (hilfe.height() + 40);
            if (neuehoehe < idlehoehe) {
                hilfe.animate(
                    { top: neuehoehe },
                    400,
                    () => {
                        hilfe.find('p').css('visibility', 'visible');
                    }
                );
            } else {
                hilfe.find('p').css('visibility', 'visible');
            }
        },
        rollIdle() {
            // var view = this;
            const fensterhoehe = $(window).height();
            const hilfe = $('#help');
            const neuehoehe = fensterhoehe - 163;

            hilfe.css('height', hilfe.height() + 'px');
            hilfe.find('p').css('visibility', 'hidden');
            let helptext = '';
            if (Globals.i18n.data['general.help.helptext']) {
                helptext = Globals.i18n._('general.help.helptext');
            }
            hilfe.find('p').html(helptext);


            hilfe.animate(
                { top: neuehoehe },
                400,
                () => {
                    hilfe.css('height', 'auto');
                    hilfe.find('p').css('display', 'none');
                    hilfe.find('p').css('visibility', 'visible');
                    hilfe.find('p').fadeIn('fast');
                }
            );
        }

    });
    return HelpView;
});



// WEBPACK FOOTER //
// ./src/components/app/views/HelpView.js